module.exports = __webpack_public_path__ + "img/AlbertEinstein.992a3747.jpg";